import React from 'react'
import {BarChart, ReferenceLine, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend} from 'recharts'
import {mesesExtenso3} from '../../Helpers/date';

const SimpleBarChart = props => {
  let { data, dataKeys, modif } = props
  data = data.map((v,i) => ({
    name: mesesExtenso3[i],
    ...v
  }))
  return (
    <BarChart width={600} height={300} data={data}>
      <CartesianGrid strokeDasharray="3 3"/>
      <XAxis dataKey="name" padding={{left: 30, right: 30}}/>
      <YAxis allowDecimals={false} />
      <Tooltip formatter={modif} />
      <Legend />
      <ReferenceLine y={0} stroke="black"/>
      {dataKeys.map(([attr,attrKey]) => (
        <Bar name={attr} dataKey={attrKey} fill="green" />
      ))}
    </BarChart>
  );
}

export default SimpleBarChart
